import React from 'react';
import classnames from 'classnames';
import { DataRangeFormPicker } from 'components/common/data-range-form-picker';
import { defaultPresetKeys } from './constants';
import styles from './statistics-date-range-picker.module.scss';
import type { IStatisticsDateRangePickerProps } from './types';
import { disabledPickerDates, getPresets } from './utils';

export const StatisticsDateRangePicker: React.FC<IStatisticsDateRangePickerProps> = (props) => {
  const { handleSuccess, disabledMonths = 1, presets = defaultPresetKeys, className } = props;

  const disabledDates = disabledPickerDates(disabledMonths, 'months');
  const rangePresets = getPresets(presets);
  const classNames = classnames(styles.formItem, className);

  return (
    <DataRangeFormPicker
      name='date'
      label='Date'
      className={classNames}
      handleSuccess={handleSuccess}
      rangePresets={rangePresets}
      disabledDate={disabledDates}
      isRequired
    />
  );
};
